module.exports = __webpack_public_path__ + "static/media/popup_mobile-tablet.76ee6359.webp";